export const PAGINATION_OPTIONS = [10, 25, 50];

export const TABLE_PAGINATION_ROWS_PER_PAGE_SELECT_ID = "table-pagination-rows-per-page-select";
